<template>
	<div class="swiperBox">
		<div class="swiper-container" id="toggleMvSw">
			<div class="swiper-wrapper">
				<div class="swiper-slide" v-for="(item,index) in toggleMvList" :key='item.id'>
					<img :src="item.cover" class="swiperImg" @click="toggleMv(index)" />
				</div>
			</div>
		</div>
		<div class="swiper-button-prev"></div>
		<div class="swiper-button-next"></div>
	</div>
</template>

<script>
	import Swiper from 'swiper'
	export default {
		name: 'swiper',
		props: ['toggleMvList'],
		mounted: function() {
			//配置Swiper  建议关于Swiper配置方面可以前往Swiper官网
			new Swiper('#toggleMvSw', {
				freeMode: true,
				slidesPerView: 5,
				spaceBetween: 30,
				direction: 'horizontal',
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				observer: true, //很重要
			})
		},
		methods: {
			toggleMv: function(index) {
				this.$emit('getToggleMv', index)
			}
		}
	}
</script>

<style scoped>
	.swiperBox {
		width: 1000px;
		height: 261px;
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
	}

	.swiper-container {
		background: none;
		width: 100%;
		height: 100%;
	}

	.swiperImg {
		width: 100%;
		height: 100%;
		object-fit: cover;
		display: block;
		cursor: pointer;
	}

	.swiper-button-next,
	.swiper-container-rtl .swiper-button-prev {
		right: -100px;
	}

	.swiper-button-prev,
	.swiper-container-rtl .swiper-button-next {
		left: -100px;
	}

	.swiper-button-next,
	.swiper-button-prev {
		background: #696568;
		padding: 10px;
		color: #282326;
		outline: none !important;
		border: none !important;
	}
</style>
